<!-- 新增收货地址页 -->
<template>
  <div class="addlist">

     <!-- <div class="unifiedBindCard_title" @click="cardBackpage" > 
        <div class="unifiedBindCard_title_one">
          <div><img src="@/assets/img/images/back_img.png" alt=""></div>
          <div>返回</div>
          <div></div>
        </div>
     </div> -->

    <div class="list_container" v-for="(item, index) in userList" :key="'list_container' + index">
      <div class="list_header">
        <p class="list_header_user">
          <span class="name">{{item.consignee}}</span>
          <span class="phone">{{item.mobile}}</span>
        </p>
        <p class="list_header_address"  @click="ToYewu(item)">
          <img src="@/assets/img/images/dingwei.png" alt="">
          <span>{{item.province + item.city + item.district + item.town + item.address}}</span>
        </p>
      </div>
      <div class="list_center">
        <div class="list_center_left" >
          <input type="radio" :value="item.isDefault" :checked="item.isDefault == 0 ? false : true " @click="isToBase(item)">
            <span :class="item.isDefault == 1 ? 'colorRed' : '' ">{{ item.isDefault == 0 ? '设为默认' : '已设默认' }}</span>
        </div>
        <div class="list_center_right">
          <div class="list_center_right_edit" @click="edit(item)">
            <img src="@/assets/img/images/edit.png" alt="" >
            <span>编辑</span>
          </div>
          <div class="list_center_right_del" @click="delBtn(item.addId)">
            <img src="@/assets/img/images/del_img.png" alt="" >
             <!-- @cancle="AddTextTextFun(index)" @next="delOrderFun(item.id)" -->
            <span>删除</span>
          </div>
        </div>
      </div>
    </div>
     <div v-if="userList.length==0" class="center_box_list03">未找到您的地址,请先添加收货地址吧~</div>
    <div class="list_addButton" @click="save" :style="{background: `${colourName}`}"> + 新增收货地址 </div>
    <Bounced type='confirm' @took='queRenOk' @tocancel='() => showDio = false ' :showstate='showDio' >
       <span slot='tlt'>提示</span>  <div slot='text'>确定要删除么?</div>
    </Bounced>
  </div>
</template>
<script>
import * as api from "@/api";
import JmmToast from '@/components/JmmToast'
import VuePicker from "vue-pickers";
import cityData from "@/utils/CityData.js"
import Bounced from "@/components/Bounced";
let realnameRegular = /^[\u0391-\uFFE5]+$/;
const deepFreeze = function(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    propNames.forEach(function(name) {
      var prop = obj[name];
      if (typeof prop == 'object' && prop !== null) {
        deepFreeze(prop);
      }
    })
    return Object.freeze(obj)
  }
  // 冻结以提升性能
  const freezeCityData = deepFreeze(cityData)

 import checkCai from '@/assets/img/images/radio.png';
 import checkHui from '@/assets/img/images/radio_greay.png';
       
export default {
  name: "login",
  data() {
    return {
      colourName: '#fb4e4d',
      radioName: require("../../assets/img/images/radio.png"),
      person: '',           // 此字段主要判断是不是从个人中心 进来的页面,方便返回跳转
      cardrights: '',
      fromAddress: '',
      showDio: false, // 弹框组件
      uid: '', // 获取的 userid
      id: '', // 获取的 要删除的id
      token: "",
      sign: "",
      showToolbar: true,
      pickerVisible: false,
      pickData: freezeCityData,
      page: 1,
      rows: 100,
      total: null,   // 分页数据
      checkCai: checkCai,
      checkHui: checkHui,
      checked: false,
      return_url: '',  // 业务方 跳转的 地址,判断是 从订单详情页 还是 我的页面
      consignee:"",
      mobile:"",
      province:"",
      city:"",
      userList: "", //  列表数据
      address:"",
      channel: '',           // 判断渠道ID
    };
  },
  components: { VuePicker, Bounced },
  mounted () {
    // history.pushState(null, null, location.href);
    //   window.history.forward(1);  // 此行可以兼容 IE
    //   window.addEventListener('popstate', function(event) {
    //       history.pushState(null, null, location.href );
    //       window.history.forward(1);
    //       //此处加入回退时你要执行的代码
    //  }); 
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    // 色调选择
    this.displayType = localStorage.getItem("displayType");
    if(this.displayType === '0'){
      this.colourName = "#f8992d";
      this.radioName = require("../../assets/img/images/new/radio.png")
    }
    this.person = this.$route.query.person
    this.return_url = this.$route.query.return_url
    if (this.return_url != '') {
      localStorage.setItem('addressUrl', window.location.href.split('return_url=')[1]) 
      // localStorage.setItem('addressUrl', this.return_url) 
    }
    this.cardrights = this.$route.query.cardrights;
    this.sign = this.$route.query.sign;
    if(null == this.sign || undefined == this.sign){
      this.sign = '';
    }
    if('' == this.sign){
      this.sign = localStorage.getItem('codeSign');
    }else{
      localStorage.setItem('codeSign', this.sign);
    }
    this.token = this.$route.query.token;
    if(null == this.token || undefined == this.token){
      this.token = '';
    }
    if('' != this.token){
      localStorage.setItem('reToken', this.token);
    }

    this.channel = this.$route.query.channel
    //判断渠道ID
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }   
    this.fetch()
  },
  computed: {
    styleVar() {
      return {
        '--colourName': this.colourName,
        '--radioName': this.radioName
      }
    }
  },
  methods: {
  //   cardBackpage: function() {
  //    window.location.href = `https://malltest.kangou.cn/#/${this.return_url == undefined ? 'mine' : 'index'}`
  //    if (this.person) {
  //      window.location.href = `https://${window.location.host}/my.html`
  //    }
  //  },
    // 选择默认收货地址
    isToBase: async function(can) {
        let params = { "addid": can.addId,  "sign": this.sign,  }
        // localStorage.setItem('reToken', this.token);
        const res = await api.user.setDefault(params);
         if (res.code == '000000') {
           JmmToast("设置成功")
           this.fetch()
         } else {
           JmmToast(res.message)
         }
    },
    ToYewu: function(item) {
      let url = decodeURIComponent(localStorage.getItem('addressUrl'))

      this.return_url == undefined ? '' : window.location.href = `${url}${url.includes('?') ? '&' : '?'}item=${JSON.stringify(item)}`
      // this.return_url == undefined ? '' : window.location.href = `${this.return_url}${this.return_url.includes('?') ? '&' : '?'}item=${JSON.stringify(item)}`
    console.log(this.return_url, '查看返回值')
    },
    // 获取所有地址列表
    async fetch() {
      try {
        // localStorage.setItem('reToken', this.token);
        let params = {
          "page": this.page,
	        "rows": this.rows,
          "sign": this.sign
        }
        const res = await api.user.findByAll(params);
        // alert(JSON.stringify(res) + '---=-=' + JSON.stringify(params))
        if (res.code == '000000') {
          this.userList = res.data.list
          this.total = res.total
        }
      } catch (err) {
        JmmToast(res.message)
      }
    },
    // 去添加页面 添加操作
    save() {
      let url = localStorage.getItem('addressUrl')
      let sign1 = localStorage.getItem('codeSign')
      //  window.location.href = this.return_url == undefined ?  `h5address.html#/?sign=${this.sign}` : `h5address.html#/?sign=${this.sign}&return_url=${url}`
      //  alert(sign1 + '传递的sign参数==========')
       this.return_url == undefined ? window.location.href = `h5address.html#/?sign=${sign1}` : window.location.href = `h5address.html#/?sign=${sign1}&return_url=${url}`
    },
    // 编辑操作传参 待回显
    edit(item) {
       let url = localStorage.getItem('addressUrl')
      window.location.href =  this.return_url == undefined ?  `h5address.html#/?addId=${item.addId}` : `h5address.html#/?addId=${item.addId}&return_url=${url}`
      localStorage.setItem('addItem', JSON.stringify(item))
    },
    // 删除
    delBtn(id) {
      this.showDio = true
      this.id = id
    },
    // 确认执行删除操作
     async queRenOk() {
      let params = { "addid": this.id,  "sign": this.sign }
      const res = await api.user.delAddress(params);
      if(res.code == '000000'){
        JmmToast('删除成功');
        this.showDio = false
        this.fetch()
      }else{
        JmmToast(res.message);
      }
    },
  },
};
</script>

<style lang="stylus">
  @import '../../assets/css/layout.styl';
  @import '../../assets/css/common.styl';
  @import '../../assets/css/icon.css';
  @import '../../assets/css/stylesheet.css';

.addlist {
  width: 100%;
  height: 100%;
  font-size: 28px;
  overflow-x: hidden;
}

.list_container {
  background-color: #fff;
  margin-bottom: 20px;
  padding: 15px 0;
}

.list_header {
  width: calc(100% - 100px);
  margin: 0px auto;
  border-bottom: 1px solid #ddd;
  padding: 15px 0 25px 0;
}
.list_center {
  width: calc(100% - 100px);
  margin: 0px auto;
  padding: 15px 0;
}

.list_header_user .name {
  font-size: 32px;
}

.list_header_address span, .list_center span{
  color: #999;
}

.list_header_user span{
  color: #000;
}

.list_header_user .phone, .list_center_right_del,  {
 padding-left: 25px;
}
.list_center_right span {
  padding-left: 8px;
}

img {
  width: 23px;
  vertical-align: middle;
}


.list_header_address {
  padding-top: 20px;
}
.list_header_address img {
   width: 30px !important;
}

.list_center_right_edit, .list_center_right_del {
  display: flex;
  align-items:center;
}


.list_center , .list_center_right{
  display: flex;
  justify-content: space-between;
  align-items: center;
}



.list_addButton {
  width: calc(100% - 100px);
  height: 90px;
  line-height: 90px;
  background: var(--colourName);
  border-radius: 45px;
  font-size: 34px;
  text-align: center;
  color: $color;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
  z-index: 2000;
}

.list_center_left {
  .colorRed {
  }
}

.center_box_list03 {
  font-size: 28px;
  font-family: Source Han Sans SC VF;
  text-align: center;
	border-radius: 20px;
	width: 80%;
	height: 350px;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

 .unifiedBindCard_title {
  background: #f4f4f4;
  padding: 15px 0;
}

 .unifiedBindCard_title_one  {
  width calc(100% - 150px);
  font-size: 30px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

    div img {
      width: 30px;
      height: 30px;
    }
 }
</style>

<style>
.list_center_left input {
  width: .45rem;
  height: .45rem;
  box-shadow: none;
  -webkit-box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background:url('../../assets/img/images/radio_greay.png') no-repeat top center;
  background-size:.45rem .45rem;
  vertical-align: middle;
  margin-right: 5px;
}

.list_center_left input:checked{
  background:url('../../assets/img/images/new/radio.png') no-repeat top center;
  background-size:.45rem .45rem;
} 

 input[type=radio]:checked:before, input[type=radio]:before {
    display: none;
}

</style>


// WEBPACK FOOTER //
// src/view/h5addressList/index.vue